import React from 'react';
import { UpdatePhotoEvents } from './events/event-declarations';
import { builderDispatch } from '../../_utils/ui';

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';
const MAX_QUANTITY = 999;

const ListQuantityFieldHandlers = (WrappedComponent) => {
  const WithListQuantityFieldHandlers = (props) => {
    const add = (quantity) => {
      builderDispatch.dispatch({
        type: UpdatePhotoEvents.ADD_TO_SIZE,
        rootImageId: props.rootIds || props.rootId,
        targetSizeKey: props.sizeKey,
        quantity,
      });
    };

    const update = (quantity) => {
      if (props.onChange) {
        add(quantity);
        return props.onChange(quantity, props.sizeKey);
      }

      return builderDispatch.dispatch({
        type: UpdatePhotoEvents.UPDATE,
        photo: props.photos.map((photo) => ({
          client_uuid: photo.client_uuid,
          quantity,
        })),
        hard: true,
      });
    };

    const remove = () => {
      builderDispatch.dispatch({
        type: UpdatePhotoEvents.REMOVE,
        clientUuids: props.photos.map((photo) => photo.client_uuid),
      });
    };

    const quantity = () => {
      if (props.photo && props.photo.quantity) {
        return props.photo.quantity;
      }

      const sizeQuantity = props.quantity;

      function reducePhotoQuantity(memo, photo) {
        return memo + (photo.quantity || sizeQuantity || 0);
      }

      return (props.photos || []).reduce(reducePhotoQuantity, 0);
    };

    const handleQuantityChange = (e) => {
      const value = parseInt(e.target.value || 0, 10);

      if (Number.isNaN(value)) return;

      // Handle out-of-bounds values first by calling the update function.
      // This relies on the input being a controlled component, which will
      // re-render with the correct value from props.
      if (value < 0) {
        update(0, 'quantity');
        return;
      }

      if (value > MAX_QUANTITY) {
        update(MAX_QUANTITY, 'quantity');
        return;
      }

      // Handle in-bounds values.
      if (value && quantity() === 0) {
        add(value);
        return;
      }

      if (value) {
        update(value, 'quantity');
        return;
      }

      remove();
    };

    const newProps = {
      ...props,
      handleQuantityChange,
      quantity,
    };

    return <WrappedComponent {...newProps} />;
  };

  WithListQuantityFieldHandlers.displayName = `ListQuantityFieldHandlers(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithListQuantityFieldHandlers;
};

export default ListQuantityFieldHandlers;
